import queryString from "query-string"
import { useCallback, useMemo } from "react"
import { useLocation, useNavigate } from "react-router"
import { difference } from "src/common/difference"

const arrayFormat = "bracket-separator"

export function useUrlState<T>(
	defaultValue: T,
): readonly [value: T, setValue: (value: T, options?: { replace?: boolean }) => void] {
	const navigate = useNavigate()
	const { search } = useLocation()

	const value = useMemo<T>(
		() => ({
			...defaultValue,
			...queryString.parse(search, { arrayFormat }),
		}),
		[search, defaultValue],
	)

	const setValue = useCallback(
		(newValue: T, options?: { replace?: boolean }) => {
			const diff = difference(newValue as object, defaultValue)
			const stringifiedDifference = queryString.stringify(diff, {
				arrayFormat,
			})
			navigate({ search: stringifiedDifference }, { preventScrollReset: true, replace: options?.replace })
		},
		[navigate, defaultValue],
	)

	return [value, setValue]
}
